export default __webpack_public_path__ + "static/media/Local Road.8d15b00c.svg";